module.exports = __webpack_public_path__ + "img/dhfesta_logo5.58364b43.png";